// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.
import { ua } from '../../../../util/user-agent';
import { app } from '../../../app';
import { Captcha } from '../../../components/captcha/captcha.model';

app.controller('LoginControllerUsbToken', Controller);

/** @ngInject */
function Controller($scope, AuthenticationSharedService) {
    $scope.username = localStorage.getItem('username-non-fido-usb');
    $scope.rememberMe = !!$scope.username;
    const captcha = $scope.captcha = new Captcha();

    $scope.login = function () {

        AuthenticationSharedService.login({
            username: $scope.username,
            password: $scope.pin,
            oauthClientId: $rootScope.oauthClientId,
            captchaResponse: captcha.response
        })
        .then(() => {
            if ($scope.rememberMe) {
                localStorage.setItem('username-non-fido-usb', $scope.username);
            }
        })
        .finally(() => captcha.reset());
    };
    
    $scope.rememberMeChanged = function () {
        if (!$scope.rememberMe) {
            localStorage.removeItem('username-non-fido-usb');
        }
    };
    
    $scope.newLoginButton = ua.isAndroid() || ua.isIOS();
}



// WEBPACK FOOTER //
// ./src/portal/states/public/hard-token-login/usb-token-login.controller.js